<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Company</label>
        <div>
          <model-select
            :options="companyOptions"
            v-model="editCompany"
            placeholder="Company"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label for="title">Title</label>
        <div>
          <input
            name="title"
            id="title"
            type="text"
            placeholder="Title"
            v-model="editTitle"
          />
        </div>
      </div>
      <div class="form-inline">
        <label for="task">Task</label>
        <div>
          <quill-editor
            name="task"
            :options="editorOption"
            :content="editTask"
            v-model="editTask"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Project Phase</label>
        <div>
          <model-select
            :options="projectPhaseOptions"
            v-model="editProjectPhase"
            placeholder="Project Phase"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Notification</label>
        <div>
          <model-select
            :options="emailNotificationOptions"
            v-model="editEmailNotification"
            placeholder="Email Notification"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Anonymous</label>
        <div>
          <model-select
            :options="anonymousOptions"
            v-model="editAnonymous"
            placeholder="Anonymous"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="saveProject"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import spinnerButton from "@/components/public/SpinnerButton";
import * as constant from "@/constant/constant";
import moment from "moment-timezone";

export default {
  props: [
    "propsData",
    "pannelData",
    "submitLoading",
    "projectPhaseOptions",
    "companyOptions",
  ],
  components: {
    ModelSelect,
    VueCtkDateTimePicker,
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: "SAVE",
      metroOptions: [],
      publicOptions: [],
      workTypeOptions: [],
      editMetro: null,
      editLocation: null,
      editHoursPerWeek: null,
      editTitle: null,
      editTask: null,
      editPublic: null,
      editWorkType: null,
      editEngagementLength: null,
      editEstimatedStart: null,
      id: null,
      editType: null,
      editProjectPhase: null,
      editCompany: null,
      editorOption: {
        modules: {
          toolbar: [
            ["link", "bold", "italic", { list: "ordered" }, { list: "bullet" }],
          ],
        },
        theme: "snow",
      },
      editEmailNotification: false,
      emailNotificationOptions: [
        {
          value: true,
          text: "True",
        },
        {
          value: false,
          text: "False",
        },
      ],
      editAnonymous: false,
      anonymousOptions: [
        {
          value: true,
          text: "True",
        },
        {
          value: false,
          text: "False",
        },
      ],
    };
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  created: function () {
    this.initOptions();
    this.initData();
  },
  methods: {
    initOptions: function () {
      this.metroOptions = this.pannelData.metroOptions;
      this.publicOptions = this.pannelData.publicOptions;
      this.workTypeOptions = this.pannelData.workTypeOptions;
    },
    initData: function () {
      this.id = this.propsData.index;
      this.editType = this.propsData.type
        ? this.propsData.type
        : constant.PANEL_TYPES.ADD;
      if (this.editType == constant.PANEL_TYPES.ADD) {
        this.panelTitle = "Add Project";
        this.buttonLabel = "Add Project";
        this.editProjectPhase = "Active searching";
      }
      if (this.editType == constant.PANEL_TYPES.EDIT) {
        this.panelTitle = "Edit Project";
        this.buttonLabel = "Edit Project";
        this.id = this.propsData.index;
        this.editMetro = this.propsData.metro;
        this.editLocation = this.propsData.location;
        this.editHoursPerWeek = this.propsData.hoursPerWeek;
        this.editTitle = this.propsData.title;
        this.editTask = this.propsData.task;
        this.editPublic = this.propsData.public
          ? this.propsData.public.toString()
          : "false";
        this.editWorkType = this.propsData.workType;
        this.editEstimatedStart = moment(
          this.propsData.estimatedStart,
          "MM/DD/YYYY HH:mm A"
        ).format("YYYY-MM-DD HH:mm");
        this.editEngagementLength = this.propsData.engagementLength;
        this.editProjectPhase = this.propsData.phase;
        this.editCompany = this.propsData.company;
        this.editEmailNotification = this.propsData.email_notification;
        this.editAnonymous = this.propsData.is_anon ? true : false;
      }
      this.$forceUpdate();
    },
    saveProject: function () {
      const projectData = {
        id: this.id,
        type: this.editType,
        title: this.editTitle,
        task: this.editTask,
        company: this.editCompany,
        phase: this.editProjectPhase,
        emailNotification: this.editEmailNotification,
        anonymous: this.editAnonymous,
      };
      this.$emit("saveProject", projectData);
    },
  },
};
</script>
